import { isUndefined } from 'lodash-es'

export default class ListingFiltersModel {
  uriWithoutOffset = '';
  filterQueryStringVar = '';
  activeFilters = [];
  isTopLevelCategory = false;
  currentPageNumber = null;
  urlLang = '';
  activeFiltersString = '';
  duplicateNamesPerGroup = {};

  constructor (
    uriWithoutOffset,
    filterQueryStringVar,
    activeFilters,
    isTopLevelCategory,
    currentPageNumber,
    urlLang,
    activeFiltersString,
    duplicateNamesPerGroup
  ) {
    this.uriWithoutOffset = uriWithoutOffset
    this.filterQueryStringVar = filterQueryStringVar
    this.activeFilters = activeFilters
    this.isTopLevelCategory = isTopLevelCategory
    this.currentPageNumber = currentPageNumber
    this.urlLang = urlLang
    this.activeFiltersString = activeFiltersString
    this.duplicateNamesPerGroup = duplicateNamesPerGroup
  }

  isTextRangeGroup (group, entity = '', displayType = '') {
    if (isUndefined(group[entity].chunks) && group[entity].length > 0) {
      return false
    }
    return (
      (displayType === 'text-range-per-count' ||
        displayType === 'text-range-per-value') &&
      group[entity].chunks.length > 0
    )
  }

  inactivateTextRangeFilter (entry, activeFilters) {
    const chunkValueIds = entry.chunkValueIds

    activeFilters = activeFilters.filter(e => {
      return !chunkValueIds.includes(e)
    })

    return activeFilters
  }

  inactivateBaseFilter (entry, activeFilters, field = '') {
    const entryField = entry[field]

    activeFilters = activeFilters.filter(activeFilterEntryField => {
      return String(activeFilterEntryField) !== String(entryField)
    })

    return activeFilters
  }

  inactivateBaseFilterForDuplicateEntry (duplicateEntryIds, activeFilters) {
    activeFilters = activeFilters.filter(e => {
      return !duplicateEntryIds.includes(String(e))
    })

    return activeFilters
  }

  removeQueryString (group, entry, activeFilters) {
    let str = this.activeFiltersString

    if (this.activeFilters === null) {
      return ''
    }

    if (this.isTextRangeGroup(group)) {
      activeFilters = this.inactivateTextRangeFilter(entry, this.activeFilters)
    } else {
      activeFilters = this.inactivateBaseFilter(entry, this.activeFilters)
    }

    if (activeFilters.length > 0) {
      if (this.activeFiltersString !== '') {
        str += '&'
      }
      str += `${this.filterQueryStringVar}[]=${activeFilters.join(`&${this.filterQueryStringVar}[]=`)}`
    }

    return str !== '' ? `?${str}` : '/' + this.urlLang + this.uriWithoutOffset
  }

  removeQueryStringForDuplicateEntry (group, entry, activeFilters, duplicateEntryIds) {
    let str = this.activeFiltersString

    if (this.activeFilters === null) {
      return ''
    }

    activeFilters = this.inactivateBaseFilterForDuplicateEntry(
      duplicateEntryIds,
      this.activeFilters
    )

    if (activeFilters.length > 0) {
      if (this.activeFiltersString !== '') {
        str += '&'
      }
      str += `${this.filterQueryStringVar}[]=${activeFilters.join(`&${this.filterQueryStringVar}[]=`)}`
    }

    return str !== '' ? `?${str}` : '/' + this.urlLang + this.uriWithoutOffset
  }

  addQueryString (group, entry, activeFilters) {
    let str = this.activeFiltersString

    if (activeFilters === null) {
      return ''
    }

    if (activeFilters.length > 0) {
      if (this.activeFiltersString !== '') {
        str += '&'
      }
      str += `${this.filterQueryStringVar}[]=${activeFilters.join(`&${this.filterQueryStringVar}[]=`)}`
    }

    return `?${str}`
  }

  queryStringForLastActiveFilter () {
    const firstEntryString = '/' + this.urlLang + this.uriWithoutOffset
    if (this.isTopLevelCategory) {
      if (this.activeFiltersString !== '') {
        return firstEntryString + '/1' + '?' + this.activeFiltersString
      }
      return firstEntryString + '/1'
    }

    if (this.activeFiltersString !== '') {
      return firstEntryString + '?' + this.activeFiltersString
    }

    return firstEntryString
  }

  createLinkQueryStringForDuplicateEntry (group, entry, isFilterUsed, activeFilters, duplicateEntryIds) {
    let finalString = ''

    if (isFilterUsed) {
      finalString = this.removeQueryStringForDuplicateEntry(group, entry, activeFilters, duplicateEntryIds)
      if (this.activeFilters.length === duplicateEntryIds.length) {
        return this.queryStringForLastActiveFilter()
      }
    } else {
      if (this.activeFilters === null) {
        finalString = this.addQueryString(group, entry, activeFilters) + '?'
      } else {
        finalString = this.addQueryString(group, entry, activeFilters) + '&'
      }
      for (const id of duplicateEntryIds) {
        finalString += this.filterQueryStringVar + '[]=' + id
        if (id !== duplicateEntryIds[duplicateEntryIds.length - 1]) {
          finalString += '&'
        }
      }
    }

    if (this.isTopLevelCategory) {
      return '/' + this.urlLang + this.uriWithoutOffset + '/1' + finalString
    }

    return '/' + this.urlLang + this.uriWithoutOffset + finalString
  }

  createLinkQueryStringForBaseGroup (group, entry, isFilterUsed) {
    // Implement this method in the derived classes
  }

  createLinkQueryStringForRangeGroup (group, entry, isFilterUsed) {
    // Implement this method in the derived classes
  }

  createLinkQueryStringFinal (group, entry, isFilterUsed) {
    // Implement this method in the derived classes
  }
}
